import React, { Component } from "react"
import MapOverviewElement from "./mapOverviewElement"
import config from "react-global-configuration"

class MapOverview extends Component {
  getOverviewElementData = (allProducts, textKeys) => {
    let categoryNames = allProducts.map((item) => {
      return item.product.categoryName
    })
    categoryNames = categoryNames.filter((name, index) => categoryNames.indexOf(name) === index)
    let overviewData = categoryNames.map((name) => {
      let data = {}
      data.categoryName = name
      data.color = allProducts.find(
        (element) => element?.product?.dynamicFields?.productColor && element?.product?.categoryName === name,
      )?.product?.dynamicFields?.productColor
      data.carParks = allProducts
        .filter((item) => {
          if (item?.product?.categoryName === data.categoryName) return item
          return null
        })
        .map((item) => item.carPark.name)
      data.carParks = data.carParks.filter((carPark, index) => data.carParks.indexOf(carPark) === index)
      return data
    })

    let campaignProducts = allProducts.filter(
      (item) =>
        (item.carPark.code !== "P4S" && item.product.categoryName !== "Medarbejdertilbud" && item.result.showPayOnFootPrice) ||
        (this.props.affiliateCode &&
          this.props.affiliateCode.toLowerCase() !== "hcp" &&
          this.props.affiliateCode.toLowerCase() !== "cpp" &&
          item.result.affiliateResult &&
          item.product.dynamicFields.affiliateBanner),
    ) // do not show overview element for handicap car park
    overviewData = [
      ...overviewData,
      ...campaignProducts.map((item) => {
        // dont show affiliateBanner if affiliateCode is HCP or CPP
        return {
          categoryName:
            this.props.affiliateCode &&
            this.props.affiliateCode.toLowerCase() !== "hcp" &&
            this.props.affiliateCode.toLowerCase() !== "cpp" &&
            item.product.dynamicFields.affiliateBanner
              ? item.product.dynamicFields.affiliateBanner
              : `${textKeys.campaign || "Kampagne"} ${item.carPark.code}`,
          color: "#fecb00",
        }
      }),
    ]
    if (this.props.globals.validPromotionCode) {
      overviewData = [...overviewData, { categoryName: this.props.globals.promotionName, color: "#fecb00" }]
    }
    overviewData = overviewData.filter((value, index) => {
      const _value = JSON.stringify(value)
      return (
        index ===
        overviewData.findIndex((obj) => {
          return JSON.stringify(obj) === _value
        })
      )
    })
    return overviewData
  }

  render() {
    const { allProducts } = this.props
    const isSoldOutProducts = allProducts.filter((item) => item.product.isSoldOut)
    const textKeys = config.get("textKeys.parkingList.listElement")
    return (
      <div className="parking-legend">
        <ul>
          {this.getOverviewElementData(allProducts, textKeys).map((element) => {
            return (
              <MapOverviewElement
                key={element.categoryName}
                categoryName={element.categoryName}
                carParks={element.carParks}
                color={element.color}
                getClass={this.props.getClass}
              />
            )
          })}
          {isSoldOutProducts && isSoldOutProducts.length > 0 ? (
            <li className="parking-legend__item parking-legend__item--soldout">
              <span className="icon">
                <span>P</span>
              </span>
              <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
            </li>
          ) : null}
        </ul>
      </div>
    )
  }
}
export default MapOverview
